export const RUTA_SORBY_IA = '/sorby-ia';

// Cuentas que tienen Sorby IA: alta sola o con la ventana de onboarding web (abierta o no).
export const tieneSorbyIa = (empresa) => !!(empresa?.alta_sola || empresa?.onboarding_web);

// El menú recortado es solo de la cuenta de alta sola. La cuenta que ya no es de alta sola pero
// sigue en onboarding conserva el menú completo, con Sorby IA primero (ver sorbyIaPrimero).
export const tieneMenuRecortado = (empresa) => !!empresa?.alta_sola;

// Solo estas cuentas necesitan preguntarle al servidor si la ventana de onboarding sigue abierta.
export const debeConsultarOnboarding = (empresa) => !!(empresa?.onboarding_web && !empresa?.alta_sola);

// `onboardingActivo` es el estado del servidor (hay pasos pendientes); solo importa si no es alta sola.
export const sorbyIaPrimero = (empresa, onboardingActivo) =>
  !tieneMenuRecortado(empresa) && debeConsultarOnboarding(empresa) && onboardingActivo === true;

export const aterrizaEnSorbyIa = (empresa, onboardingActivo) =>
  tieneMenuRecortado(empresa) || sorbyIaPrimero(empresa, onboardingActivo);

// Ruta a la que redirige la raíz, o null si la empresa sigue en su aterrizaje de siempre.
export const rutaDeAterrizaje = (empresa, onboardingActivo) => {
  if (empresa?.vertical === 'corralon') return '/dashboard-corralon';
  return aterrizaEnSorbyIa(empresa, onboardingActivo) ? RUTA_SORBY_IA : null;
};

export const rutaCaja = (empresaId) => `/cajas?empresaId=${empresaId}&vista=todos`;

export const ITEM_SORBY_IA = { id: 'sorby-ia', title: 'Sorby IA', path: RUTA_SORBY_IA };

// Sorby IA primero; Cajas y Presupuestos exigen ser admin de cajas, igual que en el menú completo.
export const itemsMenuAltaSola = ({ empresaId, esAdmin }) => [
  ITEM_SORBY_IA,
  ...(esAdmin
    ? [
        { id: 'movimientos', title: 'Cajas', path: rutaCaja(empresaId) },
        { id: 'presupuestos', title: 'Presupuestos', path: '/control-presupuestos' },
      ]
    : []),
  { id: 'reportes', title: 'Reportes', path: '/reportes' },
];
